var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMatches } from 'react-router-dom';
import { Box, Typography } from '@lucidlink/uicore';
import { HEADER_PORTAL_ID } from '#constants';
import { getHeading } from '#services';
export const PageHeading = () => {
    _react_refresh_temp_2();
    const routesArray = useMatches();
    const handle = routesArray.at(-1)?.handle;
    const heading = handle && handle.heading ? getHeading()[handle.heading] : '';
    return (_jsxs(Box, { align: "center", gap: "sm", children: [_jsx("div", { id: HEADER_PORTAL_ID }), _jsx(Typography, { as: "h1", color: "accent", "data-testid": "page-heading", kind: "h5", children: heading })] }));
};
_react_refresh_temp_1 = PageHeading;
$RefreshReg$(_react_refresh_temp_1, "PageHeading");
_react_refresh_temp_2(PageHeading, "IjntwvrU7DCoGHmGdT0vZlISRM8=", false, () => [useMatches]);
